import { setCurrentUser, getCurrentUser } from '@/utils'

export default (to, from, next) => {
  if (to.matched.some((record) => record.meta.loginRequired)) {
    const user = getCurrentUser()
    if (user) {
      const roleArrayHierarchic = to.matched.filter((x) => x.meta.roles).map((x) => x.meta.roles)
      if (roleArrayHierarchic.every((x) => x.includes(user.role))) {
        next()
      } else {
        next('/unauthorized')
      }
    } else {
      setCurrentUser(null)
      next('/auth/login')
    }
  } else {
    next()
  }
}
